// extracted by mini-css-extract-plugin
module.exports = {"textEllipsis":"Item_textEllipsis__MQoKW","container":"Item_container__28M2k","icon":"Item_icon__2qfec","hover":"Item_hover__3X6xa","text":"Item_text__29h9Q"};